import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Innovation.css';

const Innovation = () => {
  const innovations = [
    {
      title: 'AI-Powered Legal Research',
      description: 'Advanced artificial intelligence for rapid case analysis and precedent discovery',
      icon: 'AI',
      tag: 'Technology'
    },
    {
      title: 'Blockchain Solutions',
      description: 'Smart contracts and distributed ledger applications for secure transactions',
      icon: 'DLT',
      tag: 'Fintech'
    },
    {
      title: 'ESG Advisory',
      description: 'Comprehensive environmental, social, and governance compliance strategies',
      icon: 'ESG',
      tag: 'Sustainability'
    },
    {
      title: 'Quantum Computing Readiness',
      description: 'Preparing clients for the quantum era with future-proof legal frameworks',
      icon: 'QC',
      tag: 'Future Tech'
    }
  ];

  return (
    <section className="innovation">
      <div className="innovation-bg">
        <div className="innovation-mesh"></div>
      </div>

      <div className="section-container">
        <motion.div
          className="innovation-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">INNOVATION</span>
          <h2 className="section-title">
            Leading the Future
            <br />
            <span className="title-accent">of Legal Services</span>
          </h2>
          <p className="section-description">
            Embracing cutting-edge technology and innovative methodologies to deliver
            unprecedented value and efficiency to our clients worldwide.
          </p>
        </motion.div>

        <div className="innovation-grid">
          {innovations.map((item, index) => (
            <motion.div
              key={item.title}
              className="innovation-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="innovation-card-inner">
                <div className="innovation-card-front">
                  <div className="innovation-icon">{item.icon}</div>
                  <span className="innovation-tag">{item.tag}</span>
                  <h3 className="innovation-title">{item.title}</h3>
                  <p className="innovation-description">{item.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="innovation-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="innovation-cta-content">
            <h3>Ready to Transform Your Legal Operations?</h3>
            <p>Discover how our innovative solutions can give you a competitive advantage</p>
            <Link to="/contact" className="innovation-cta-btn">
              Schedule a Consultation
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" strokeWidth="2" />
              </svg>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Innovation;
